import { useEffect, useState } from 'react';
import {
  collection,
  addDoc,
  deleteDoc,
  doc,
  onSnapshot,
  orderBy,
  query,
  serverTimestamp,
} from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
import { db, storage } from '../../firebase';

export default function AdminWorks() {
  const [works, setWorks] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const q = query(collection(db, 'works'), orderBy('createdAt', 'desc'));
    const unsubscribe = onSnapshot(q, (snap) => {
      setWorks(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
    });
    return unsubscribe;
  }, []);

  const onUpload = async (e) => {
    const files = Array.from(e.target.files || []);
    if (files.length === 0) return;

    setUploading(true);
    setError('');
    try {
      for (const file of files) {
        const storagePath = `works/${Date.now()}_${file.name}`;
        const storageRef = ref(storage, storagePath);
        await uploadBytes(storageRef, file);
        const url = await getDownloadURL(storageRef);

        await addDoc(collection(db, 'works'), {
          storagePath,
          url,
          legacy: false,
          createdAt: serverTimestamp(),
        });
      }
    } catch (err) {
      setError('アップロードに失敗しました。');
    } finally {
      setUploading(false);
      e.target.value = '';
    }
  };

  const onDelete = async (work) => {
    if (!window.confirm('この作品を削除しますか？')) return;
    try {
      await deleteObject(ref(storage, work.storagePath));
    } catch (err) {
      // ファイルが既に存在しない場合は無視して続行
    }
    await deleteDoc(doc(db, 'works', work.id));
  };

  return (
    <div className="admin-panel">
      <label className="admin-dashboard__upload">
        <input type="file" accept="image/*" multiple onChange={onUpload} disabled={uploading} hidden />
        {uploading ? 'アップロード中...' : '＋ 作品を追加'}
      </label>

      {error && <p className="admin-dashboard__error">{error}</p>}

      <div className="admin-dashboard__grid">
        {works.map((w) => (
          <div key={w.id} className="admin-dashboard__item">
            <img src={w.url} alt="作品" />
            <button className="admin-dashboard__delete" onClick={() => onDelete(w)}>削除</button>
          </div>
        ))}
      </div>

      {works.length === 0 && <p className="admin-dashboard__empty">作品がまだありません。</p>}
    </div>
  );
}
